export default "__VITE_ASSET__0c309d9d__"